<template>
  <div>
    <full-page ref="fullpage" :options="options">
      <div class="section agribg">
        <div class="container" style="height: calc(100vh - 80px)">
          <div class="d-flex align-items-center">
            <div class="">
              <div class="">
                <img
                  src="https://res.gosmart.mn/media/logo/vet.png"
                  class="rounded-circle img-thumbnail wd-150 mg-b-20"
                />
                <h4 class="tx-xs-20 tx-uppercase tx-brand-02">
                  Мал эмнэлгийн ерөнхий газар
                </h4>
                <h4 class="home-headline">
                  Мал амьтны <span>эм, тэжээлийн нэмэлтийн</span> бүртгэлийн
                  <br />
                  нэгдсэн мэдээллийн <span>санд</span> тавтай морилно уу.
                </h4>
              </div>
              <div class="row mg-t-50 mg-b-30">
                <div class="col-sm-2 text-center">
                  <a
                    @click="$router.push({ name: 'vetLandingMeds' })"
                    role="button"
                    class="text-center"
                  >
                    <div class="icon-container pd-5">
                      <img
                        src="https://res.gosmart.mn/apps/vet.med/icon1.jpg"
                        class="rounded-circle img-thumbnail"
                        alt=""
                      />
                    </div>
                    <h6 class="mg-t-20 text-uppercase">
                      Бүртгэлтэй эм, бэлдмэлүүд
                    </h6>
                  </a>
                </div>
                <div class="col-sm-2 text-center">
                  <a
                    @click="$router.push({ name: 'vetLandingLics' })"
                    role="button"
                    class="text-center"
                  >
                    <div class="icon-container pd-5">
                      <img
                        src="https://res.gosmart.mn/apps/vet.med/icon2.jpg"
                        class="rounded-circle img-thumbnail"
                        alt=""
                      />
                    </div>
                    <h6 class="mg-t-20 text-uppercase">
                      Тусгай зөвшөөрөлтэй аж ахуйн нэгж
                    </h6>
                  </a>
                </div>
                <div class="col-sm-2 text-center">
                  <a
                    href="http://help.vetdrug.mn"
                    target="_blank"
                    role="button"
                    class="text-center"
                  >
                    <div class="icon-container pd-5">
                      <img
                        src="https://res.gosmart.mn/apps/vet.med/icon3.jpg"
                        class="rounded-circle img-thumbnail"
                        alt=""
                      />
                    </div>
                    <h6 class="mg-t-20 text-uppercase">Гарын авлага</h6>
                  </a>
                </div>
                <div class="col-sm-2 text-center">
                  <a
                    @click="$router.push({ name: 'login' })"
                    role="button"
                    class="text-center"
                  >
                    <div class="icon-container pd-5">
                      <img
                        src="https://res.gosmart.mn/apps/vet.med/icon4.jpg"
                        class="rounded-circle img-thumbnail"
                        alt=""
                      />
                    </div>
                    <h6 class="mg-t-20 text-uppercase">Аж ахуй нэгж</h6>
                    <div class="btn btn-success btn-xs">нэвтрэх</div>
                  </a>
                </div>
                <div class="col-sm-2 text-center">
                  <a
                    @click="$router.push({ name: 'login' })"
                    role="button"
                    class="text-center"
                  >
                    <div class="icon-container pd-5">
                      <img
                        src="https://res.gosmart.mn/apps/vet.med/icon5.jpg"
                        class="rounded-circle img-thumbnail"
                        alt=""
                      />
                    </div>
                    <h6 class="mg-t-20 text-uppercase">Салбар зөвлөл</h6>
                    <div class="btn btn-success btn-xs">нэвтрэх</div>
                  </a>
                </div>
                <div class="col-sm-2 text-center">
                  <a
                    @click="$router.push({ name: 'login' })"
                    role="button"
                    class="text-center"
                  >
                    <div class="icon-container pd-5">
                      <img
                        src="https://res.gosmart.mn/apps/vet.med/icon6.jpg"
                        class="rounded-circle img-thumbnail"
                        alt=""
                      />
                    </div>
                    <h6 class="mg-t-20 text-uppercase">Фармакопейн хороо</h6>
                    <div class="btn btn-success btn-xs">нэвтрэх</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class=""
          style="height: 80px; background-image: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,1));"
        >
          <div
            @click="$refs.fullpage.api.moveSectionDown()"
            role="button"
            class="text-center tx-white container"
          >
            <div>
              <h5 style="margin-bottom: 0px; color: white">Эхлэл</h5>
              <feather type="chevrons-down"></feather>
            </div>
          </div>
        </div>
      </div>
      <div
        class="section"
        style="background: url('https://res.gosmart.mn/media/bg/pattern.png');"
      >
        <div class="container bg-white">
          <div class="d-flex mg-y-20">
            <h4 class="pd-10 bd-l bd-3">
              Системийн <span class="tx-brand-02">заавар</span>
            </h4>
            <div class="mg-l-auto">
              <a
                href="http://help.vetdrug.mn"
                target="_blank"
                class="btn btn-primary btn-xs text-white"
                >Зааврыг дэлгэрэнгүй үзэх</a
              >
            </div>
          </div>
          <ul class="steps mg-l-60">
            <li class="step-item text-center">
              <a
                target="_blank"
                href="http://help.vetdrug.mn/#/vet-landing-help/45047/1377723"
                class="step-link"
              >
                <div class="text-center">
                  <img
                    src="https://res.gosmart.mn/apps/vet.med/step1.png"
                    class="wd-150 mg-b-10"
                  />
                  <span class="step-title">Аж ахуй нэгж</span>
                  <span class="step-desc">системд нэвтрэх эрх авах</span>
                </div>
              </a>
            </li>
            <li class="step-item text-center">
              <a
                target="_blank"
                href="http://help.vetdrug.mn/#/vet-landing-help/45050/1378859"
                class="step-link"
              >
                <div class="text-center">
                  <img
                    src="https://res.gosmart.mn/apps/vet.med/step2.png"
                    class="wd-150 mg-b-10"
                  />
                  <span class="step-title">Компани</span>
                  <span class="step-desc">мэдээллээ шинэчлэх</span>
                </div>
              </a>
            </li>
            <li class="step-item text-center">
              <a
                target="_blank"
                href="http://help.vetdrug.mn/#/vet-landing-help/45048/1378865"
                class="step-link"
              >
                <div class="text-center">
                  <img
                    src="https://res.gosmart.mn/apps/vet.med/step3.png"
                    class="wd-150 mg-b-10"
                  />
                  <span class="step-title">Тусгай зөвшөөрөл</span>
                  <span class="step-desc">хүсэлт илгээх</span>
                </div>
              </a>
            </li>
            <li class="step-item text-center">
              <a
                target="_blank"
                href="http://help.vetdrug.mn/#/vet-landing-help/45049/1378889"
                class="step-link"
              >
                <div class="text-center">
                  <img
                    src="https://res.gosmart.mn/apps/vet.med/step4.png"
                    class="wd-150 mg-b-10"
                  />
                  <span class="step-title">Эм, бэлдмэл</span>
                  <span class="step-desc">бүртгүүлэх хүсэлт</span>
                </div>
              </a>
            </li>
            <li class="step-item text-center">
              <a
                target="_blank"
                href="http://help.vetdrug.mn/#/vet-landing-help/45052/1378906"
                class="step-link"
              >
                <div class="text-center">
                  <img
                    src="https://res.gosmart.mn/apps/vet.med/step5.png"
                    class="wd-150 mg-b-10"
                  />
                  <span class="step-title">Эм импортлох</span>
                  <span class="step-desc">лицензийн хүсэлт</span>
                </div>
              </a>
            </li>
          </ul>
          <div class="row mg-t-20">
            <div class="col-md-12">
              <div class="d-flex mg-t-10">
                <h4 class="pd-10 bd-l bd-3">
                  Мэдээ <span class="tx-brand-02">мэдээлэл</span>
                </h4>
                <div class="mg-l-auto">
                  <ul class="nav nav-line pd-x-20 tx-15">
                    <li
                      class="nav-item"
                      v-for="(c, i) in news_category"
                      :key="i"
                    >
                      <a
                        @click="loadNewsByCategory(c.id)"
                        role="button"
                        class="nav-link"
                        :class="{ active: news_category_cur == c.id }"
                        >{{ c.title }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div style="min-height: 666px">
                <b-overlay
                  :show="news_loading"
                  rounded="sm"
                  class="pd-y-20 pd-x-20"
                >
                  <template v-if="news.length > 0">
                    <div
                      @click="newsDetail(t)"
                      role="button"
                      class="media mg-y-10"
                      v-for="(t, i) in news"
                      :key="i"
                    >
                      <img
                        :src="`${t.defaultAttachmentUrl}?w=200&h=100&mode=crop`"
                        class="wd-200 rounded mg-r-20"
                        alt=""
                      />
                      <div class="media-body">
                        <h5 class="mg-b-5 tx-inverse">{{ t.task }}</h5>
                        <div
                          style="min-height: 60px; max-height:60px"
                          class="lh-xs-2"
                        >
                          {{ t.f1 }}
                        </div>
                        <h6 class="text-muted tx-12">
                          {{ t.createdDate | moment("dddd, YYYY.MM.DD HH:mm") }}
                        </h6>
                      </div>
                    </div>
                  </template>
                  <div v-else>
                    <div
                      class="container d-flex justify-content-center ht-100p"
                    >
                      <div
                        class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
                      >
                        <div class="wd-80p wd-sm-300 mg-b-15">
                          <img
                            src="assets/svg/boxempty.svg"
                            class="img-fluid"
                            alt=""
                          />
                        </div>
                        <h4 class="tx-20 tx-sm-24 text-muted">
                          Мэдээлэл хоосон байна
                        </h4>
                      </div>
                    </div>
                  </div>
                </b-overlay>
              </div>
            </div>
          </div>
        </div>
        <div class="container" style="padding: 0">
          <footer
            class="page-footer font-small pt-4"
            style="background-color: rgba(33, 150, 243)"
          >
            <div class="container-fluid text-white text-center text-md-left">
              <div class="row">
                <div class="col-md-5 mt-md-0 mt-3">
                  <h5 class="text-uppercase text-white">ХОЛБОО БАРИХ</h5>
                  <p>
                    Монгол улс, Улаанбаатар хот 13381 Баянзүрх дүүрэг,
                    Энхтайваны өргөн чөлөө 16а, Засгийн газрын IXа байр.
                  </p>
                  <h5 class="text-uppercase text-white">УТАС</h5>
                  <p>76114665</p>
                </div>
                <hr class="clearfix w-100 d-md-none pb-3" />
                <div class="col-md-3 mb-md-0 mb-3">
                  <h5 class="text-uppercase text-white">Хэрэгтэй холбоосууд</h5>

                  <ul class="list-unstyled">
                    <li class="mg-b-10">
                      <a
                        class="text-white"
                        target="_blank"
                        href="http://mofa.gov.mn"
                        >Хүнс хөдөө аж ахуйн яам</a
                      >
                    </li>
                    <li class="mg-b-10">
                      <a
                        class="text-white"
                        target="_blank"
                        href="http://vet.gov.mn"
                        >Мал эмнэлгийн ерөнхий газар</a
                      >
                    </li>
                    <li class="mg-b-10">
                      <a
                        class="text-white"
                        target="_blank"
                        href="http://vet.certificate.mn"
                        >Мал эмнэлгийн нэгдсэн систем</a
                      >
                    </li>
                    <li>
                      <a
                        class="text-white"
                        target="_blank"
                        href="http://shilendans.gov.mn"
                        >Шилэн дансны мэдээлэл</a
                      >
                    </li>
                  </ul>
                </div>

                <div class="col-md-4 mb-md-0 mb-3">
                  <iframe
                    src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FGavsmongolia%2F&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=1423578614577121"
                    width="340"
                    height="130"
                    style="border:none;overflow:hidden"
                    scrolling="no"
                    frameborder="0"
                    allowfullscreen="true"
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  ></iframe>
                </div>
              </div>
            </div>
            <div
              class="footer-copyright text-center py-3 text-white"
              style="background-color: rgba(0,0,0,0.2)"
            >
              © 2020.
              <a class="text-white" href="http://vet.gov.mn" target="_blank"
                >МАЛ ЭМНЭЛГИЙН ЕРӨНХИЙ ГАЗАР</a
              >
            </div>
          </footer>
        </div>
      </div>
    </full-page>

    <b-modal
      v-model="modal.show"
      :title="modal.task.task"
      scrollable
      size="xl"
      no-fade
      hide-footer
    >
      <div class="my-4 mx-4" v-html="modal.task.taskDesc"></div>
    </b-modal>
  </div>
</template>

<style scoped>
.agribg {
  background: url("https://res.gosmart.mn/apps/vet.med/bg.jpg");
  background-size: cover;
  background-position: top center;
}
@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
</style>
<style>
html {
  overflow: auto !important;
}
</style>

<script>
import { request } from "@/api/all";
var $ = window.$;

export default {
  data() {
    return {
      news_loading: false,
      news: [],
      news_category: [],
      news_category_cur: 0,
      options: {
        licenseKey: "YOUR_KEY_HEERE",
        sectionsColor: ["gray"],
        scrollOverflow: true
      },
      modal: {
        show: false,
        task: {
          task: "",
          taskDesc: ""
        }
      }
    };
  },
  mounted() {
    this.$nextTick(function() {
      // let platformScript = document.createElement('script')
      // platformScript.setAttribute('src', 'https://res.gosmart.mn/da/assets/js/dashforge.js')
      // document.head.appendChild(platformScript)

      $(window).trigger("resize");
    });

    if (window.location.hostname == "help.vetdrug.mn") {
      this.$router.push({ name: "vetLandingHelp", params: { cid: 0, id: 0 } });
    }

    this.initNewsCategory();
  },
  // created() {
  //   window.addEventListener("resize");
  // },
  // destroyed() {
  //   window.removeEventListener("resize");
  // },
  methods: {
    initNewsCategory() {
      request({
        api: { method: "GET", url: "Type/GetTreeData" },
        params: { parentId: 0, key: "webItemCategory" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.news_category = res.data.types;
          if (res.data.types.length) {
            this.loadNewsByCategory(res.data.types[0].id);
          }
        }
      });
    },
    loadNewsByCategory(cid) {
      this.news_category_cur = cid;
      this.news = [];
      this.news_loading = true;
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          ot: 357,
          skip: 0,
          size: 5,
          model: {
            isPublic: true,
            locTypeId1: cid
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.news = res.data.tasks;
          this.news_loading = false;

          $(window).trigger("resize");
          //console.log(res.data.tasks);
        }
      });
    },
    newsDetail(t) {
      this.news_loading = true;
      request({
        api: { method: "GET", url: "Task/taskInheritedDetail" },
        params: { id: t.id },
        store: this.$store
      }).then(res => {
        this.news_loading = false;
        if (res != false) {
          this.modal.show = true;
          this.modal.task = res.data.task;
          //console.log(res.data.task);
        }
      });
    }
  }
};
</script>
